import { useShellUtilitiesStore } from '@office-start/shell-utilities-store';
import { useMemo } from 'react';
/**
 * A React SPA specific hook to listen for shell initialization events.
 *
 * In order to be backward compatible the shell-utilities-service should expose two hooks:
 * 1. useShellRenderedPromise - this is a hook that listens to the window variable for shell rendering
 * 2. useShellLoadedEvent - this is a hook that listens to the shell loaded event
 *
 * Should be straight forward to add if they are needed in the future, but would couple us to both the DOM and Angular eventing.
 *
 * @returns {IO365ShellShim | undefined} shell shim
 */
export var useShellShimReact = function () {
    var shellState = useShellUtilitiesStore();
    return useMemo(function () {
        if (shellState.rendered && window.O365Shell) {
            return window.O365Shell;
        }
        return undefined;
    }, [shellState]);
};
//# sourceMappingURL=useShellShimReact.js.map